/**
 * BEING OUT OF PLAY — the fouls, and the one that is not a foul.
 *
 * The text names the RULE and never the PRICE. How many seconds it costs is declared by the placement
 * or the conf (`reaction.sanction.outS`, `conf.grenade.foulOutS`), and a copy of that number here would go
 * stale on its own — with the sign and the countdown beside it disagreeing about the same punishment.
 */
export default {
  // The disciplinary heading, shared by every foul: what changes between them is what you did.
  title_foul: 'DISCIPLINARY PENALTY',
  // Not a foul — you were the one hit — so it does not get the disciplinary heading (§73.17).
  title_hit: 'HIT',
  // Not a foul either — nobody did it to you. Naming the fall is what stops it reading as the terrain
  // having eaten somebody; the HEIGHT is on the band (`hud.fell`), because that is the part you could not see.
  title_fall: 'FALL',

  foul_referee: 'You shot the referee.',
  // Named as "an animal" and not as the beast: it stays true the day the field carries something that is
  // not a horse.
  foul_animal: 'You shot an animal.',
  foul_min_range: 'You fired inside the minimum range.',
  foul_smoke_indoor: 'You threw smoke inside a structure. Smoke is for outdoors only.',
  foul_smoke_direct: 'You threw the can straight at a player.',
  // The only one you do not commit against anything: it happens to you. Saying the rule is what makes the
  // price yours.
  foul_vehicle: 'A vehicle ran you over. On the road, right of way is not yours.',

  hit_by: 'You were taken down by:',
  fell_from: 'You walked off a slope you cannot walk down.',
  // The sign's own two lines: the state, and how it ends. The SECONDS are not written here — they come
  // from the authority and are drawn beside this, which is what keeps one punishment from having two
  // clocks disagreeing about it.
  out_of_play: 'OUT OF PLAY',
  back_at_zero: 'You are back in the game when the count reaches zero.',

  // ── the warning, which is not a sanction ──────────────────────────────────────────────────────────
  // It happens while you go on playing, so it says what did not count rather than why you cannot move.
  warning: 'WARNING',
  warning_offence: 'A shot inside the minimum range. The hit does not count.',
  warning_line: '{d} m · your minimum is {min} m',
  warning_count: '{n} of {of}',

  // ── the log line, which is what is left afterwards ────────────────────────────────────────────────
  // Both halves exist because a sanction served by somebody else is news and one served by you is an
  // instruction: the same sentence for both would make one of the two read wrong.
  log_self: 'SANCTION — you shot the referee · {s} s out',
  log_other: '#{id} sanctioned — shot the referee · {s} s out',
};
